import React, { memo } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    fillOpacity: '0.87',
  },
});

const CloseIcon = ({ className, ...props }) => {
  const styles = useStyles();

  return (
    <SvgIcon
      viewBox="0 0 24 24"
      className={clsx(styles.icon, className)}
      fill="white"
      {...props}
    >
      <path
        d="M15.373 12L22.2673 5.10571L19.0853 1.92372L12.191 8.81801L5.29672 1.92372L2.11474 5.1057L9.00903 12L2.11473 18.8943L5.29672 22.0763L12.191 15.182L19.0853 22.0763L22.2673 18.8943L15.373 12Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </SvgIcon>
  );
};

export default memo(CloseIcon);
